import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ContactInformationForm = ({ formData, onChange, errors }) => {
  const handleChange = (field) => (e) => {
    onChange({
      ...formData,
      [field]: e?.target?.value
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-text-primary mb-1">Contact Information</h3>
        <p className="text-sm text-text-secondary">
          Business details displayed to customers during the visualizer experience
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Business Phone"
          type="tel"
          placeholder="(555) 123-4567"
          value={formData?.phone || ''}
          onChange={handleChange('phone')}
          error={errors?.phone}
          description="Primary contact number for customer inquiries"
        />

        <Input
          label="Business Email"
          type="email"
          placeholder="contact@company.com"
          value={formData?.email || ''}
          onChange={handleChange('email')}
          error={errors?.email}
          required
          description="Email address for quote requests"
        />

        <Input
          label="Website URL"
          type="url"
          placeholder="https://www.company.com"
          value={formData?.website || ''}
          onChange={handleChange('website')}
          error={errors?.website}
          description="Your company website (optional)"
        />

        <Input
          label="Business Address"
          type="text"
          placeholder="123 Main St, City, State 12345"
          value={formData?.address || ''}
          onChange={handleChange('address')}
          error={errors?.address}
          description="Physical location (optional)"
        />
      </div>
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <div className="flex items-start gap-3">
          <Icon name="MapPin" size={20} className="text-text-secondary mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-medium text-text-primary mb-1">Service Area</p>
            <Input
              type="text"
              placeholder="e.g., Greater Los Angeles Area, California"
              value={formData?.serviceArea || ''}
              onChange={handleChange('serviceArea')}
              description="Geographic region you serve"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInformationForm;